import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@styles/theme';

function MoveOutSvg(props) {
  const { fill, width, height } = props;

  let fill1 = '#262626';
  let fill2 = '#262626';

  if (Array.isArray(fill)) {
    const [first, second] = fill;
    if (first) {
      fill1 = first;
    }
    if (second) {
      fill2 = second;
    }
  } else if (fill) {
    fill1 = fill;
    fill2 = fill;
  }

  return (
    <svg width={width || 48} height={height || 48} viewBox="0 0 478.4 320">
      <g>
        <path
          style={{
            fill: fill1
          }}
          d="M238,72.8v334.8L56,336V220l97.2-1.6L238,72.8z M238,70.8L238,70.8L56,127.2L238,70.8z"
        />
        <polygon
          style={{
            fill: fill2
          }}
          points="153.2,218.8 239.2,70.8 56,127.2 0,221.2 	"
        />
        <polygon
          style={{
            fill: fill1
          }}
          points="238,70.8 238,407.6 420,336 420,220 325.2,218.8 239.6,71.2 	"
        />
        <polygon
          style={{
            fill: fill2
          }}
          points="325.2,218.8 239.2,70.8 422.4,127.2 478.4,221.2 	"
        />
      </g>
    </svg>
  );
}

MoveOutSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.any
};

MoveOutSvg.defaultProps = {
  fill: [colors.gold, colors.lightGold]
};

export default MoveOutSvg;
